export default __webpack_public_path__ + "static/image_contact-0f37ed6fc0c32c132cb3bfd6f698c399.jpg";